import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { ContactContainer } from 'src/app/interfaces/contact-container';
import { ItemComponent, ItemContainer } from 'src/app/interfaces/item-container';
import { CNConsultation, CNConsultationType } from 'src/app/models/cnconsultation';
import { CNItem } from 'src/app/models/cnitem';
import { TypeManagerService } from 'src/app/services/type-manager.service';
import * as moment from 'moment';
import { UserConfigService } from 'src/app/services/user-config.service';
import { CNServiceCode } from 'src/app/models/cnservicecode';
import { ContactService } from 'src/app/services/contact.service';

@ManageType('ContactComponent')
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  @ViewChild('contactContainer', {read: ViewContainerRef, static: true}) contactViewContainerRef: ViewContainerRef;

  private componentMapping: Map<string, any> = new Map();
  private theContact: CNConsultation = new CNConsultation();
  private contactType: CNConsultationType = CNConsultationType.Simple;
  private componentRef;

  public servicesMode = 'delete';

  constructor(private typeManager: TypeManagerService, public userConfig: UserConfigService,
              private contactSrv: ContactService) {
    this.componentMapping.set(CNConsultationType.Simple, this.typeManager.typeMap('ContactContentSimpleComponent'));
    this.componentMapping.set(CNConsultationType.RX, this.typeManager.typeMap('ContactContentRxComponent'));
    this.componentMapping.set(CNConsultationType.Kine, this.typeManager.typeMap('ContactContentKineComponent'));
    this.componentMapping.set(CNConsultationType.Logo, this.typeManager.typeMap('ContactContentLogoComponent'));
    this.componentMapping.set(CNConsultationType.Ophtalmo, this.typeManager.typeMap('ContactContentOphtalmoComponent'));
    this.componentMapping.set(CNConsultationType.Cardio, this.typeManager.typeMap('ContactContentCardioComponent'));
  }

  ngOnInit(): void {
    this.contactSrv.addCodes.subscribe(codes => {
      codes.forEach(aCode => {
        this.contact.addServiceCode(aCode);
      });
    });
  }

  @Input() set contact(acontact: CNConsultation) {
    this.theContact = acontact;
    if (this.theContact.getProperty('StVaast_Type')) {
      this.contactType = this.theContact.getProperty('StVaast_Type');
    } else {
      this.contactType = CNConsultationType.Simple;
    }
    // Check if the contact is paid to set service cmp mode
    if (this.theContact.isPaid) {
      this.servicesMode = 'none';
    }
    this.buildComponent();
  }

  get contact(): CNConsultation {
    return this.theContact;
  }

  set type(type: CNConsultationType) {
    this.contactType = type;
    // switch component
    this.buildComponent();
  }

  private buildComponent(): void {
    if (this.componentMapping.has(this.contactType) && this.contactViewContainerRef) {
      if (this.componentRef) {
        this.componentRef.destroy();
      }
      this.componentRef = this.contactViewContainerRef.createComponent<ContactContainer>(this.componentMapping.get(this.contactType));
      this.componentRef.instance.contact = this.theContact;
    }
  }

  codeAction(action: [action: string, code: CNServiceCode | CNServiceCode[]]): void {
    console.log('code action', action);
    switch (action[0]) {
      case 'add':
        {
          if (Array.isArray(action[1])) {
            action[1].forEach(aCode => {
              this.contact.addServiceCode(aCode);
            });
          } else {
            this.contact.addServiceCode(action[1]);
          }
        }
        break;
      case 'delete':
        {
          if (!Array.isArray(action[1])) {
            this.contact.removeServiceCode(action[1]);
          }
        }
        break;
    }
  }
}
